
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alquiler-pisos/viviendas",
      function () {
        return require("private-next-pages/alquiler-pisos/viviendas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alquiler-pisos/viviendas"])
      });
    }
  